import TypographyParagraph from '../../typography/TypographyParagraph'
import { Tooltip, TooltipRefProps } from 'react-tooltip'
import { useRef } from 'react'

export default function MediaCitationTemplate({
	mediaCitation,
}: {
	mediaCitation: any
}) {
	const tooltipCopyTitle = useRef<TooltipRefProps>(null)
	const tooltipCopyUrl = useRef<TooltipRefProps>(null)
	const tooltipCopyDescription = useRef<TooltipRefProps>(null)
	const tooltipCopyPublisher = useRef<TooltipRefProps>(null)
	const tooltipCopyPublishingDate = useRef<TooltipRefProps>(null)
	const tooltipCopyAuthor = useRef<TooltipRefProps>(null)
	const tooltipCopySignature = useRef<TooltipRefProps>(null)

	return (
		<>
			<div
				id="title"
				className="flex flex-row border-b border-textInactiveLight p-4 hover:bg-uiSecondaryLight dark:border-textInactiveDark dark:hover:bg-uiSecondaryDark"
				onClick={() => {
					navigator.clipboard.writeText(mediaCitation.properties.title)
					tooltipCopyTitle.current?.open({
						anchorSelect: '#title',
						content: 'Copied!',
					})
					setTimeout(() => {
						tooltipCopyTitle.current?.close()
					}, 2000)
				}}
			>
				<Tooltip imperativeModeOnly ref={tooltipCopyTitle} />
				<TypographyParagraph
					size="medium"
					additionalClasses="text-textSecondaryLight dark:text-textSecondaryDark"
				>
					Title:
				</TypographyParagraph>
				<TypographyParagraph
					size="medium"
					additionalClasses="ml-2 text-textPrimaryLight dark:text-textPrimaryDark"
				>
					{mediaCitation.properties.title}
				</TypographyParagraph>
			</div>
			<div
				id="url"
				className="flex flex-row border-b border-textInactiveLight p-4 hover:bg-uiSecondaryLight dark:border-textInactiveDark dark:hover:bg-uiSecondaryDark"
				onClick={() => {
					navigator.clipboard.writeText(mediaCitation.properties.url)
					tooltipCopyUrl.current?.open({
						anchorSelect: '#url',
						content: 'Copied!',
					})
					setTimeout(() => {
						tooltipCopyUrl.current?.close()
					}, 2000)
				}}
			>
				<Tooltip imperativeModeOnly ref={tooltipCopyUrl} />
				<TypographyParagraph
					size="medium"
					additionalClasses="text-textSecondaryLight dark:text-textSecondaryDark whitespace-nowrap mr-2"
				>
					Link:
				</TypographyParagraph>
				<TypographyParagraph
					size="medium"
					additionalClasses="text-textPrimaryLight dark:text-textPrimaryDark truncate"
				>
					{mediaCitation.properties.url}
				</TypographyParagraph>
			</div>
			{mediaCitation.properties.description && (
				<div
					id="description"
					className="flex flex-row border-b border-textInactiveLight p-4 hover:bg-uiSecondaryLight dark:border-textInactiveDark dark:hover:bg-uiSecondaryDark"
					onClick={() => {
						navigator.clipboard.writeText(mediaCitation.properties.description)
						tooltipCopyDescription.current?.open({
							anchorSelect: '#description',
							content: 'Copied!',
						})
						setTimeout(() => {
							tooltipCopyDescription.current?.close()
						}, 2000)
					}}
				>
					<Tooltip imperativeModeOnly ref={tooltipCopyDescription} />
					<TypographyParagraph
						size="medium"
						additionalClasses="text-textSecondaryLight dark:text-textSecondaryDark"
					>
						Description:
					</TypographyParagraph>
					<TypographyParagraph
						size="medium"
						additionalClasses="ml-2 text-textPrimaryLight dark:text-textPrimaryDark"
					>
						{mediaCitation.properties.description}
					</TypographyParagraph>
				</div>
			)}
			{mediaCitation.properties.publisher && (
				<div
					id="publisher"
					className="flex flex-row border-b border-textInactiveLight p-4 hover:bg-uiSecondaryLight dark:border-textInactiveDark dark:hover:bg-uiSecondaryDark"
					onClick={() => {
						navigator.clipboard.writeText(mediaCitation.properties.publisher)
						tooltipCopyPublisher.current?.open({
							anchorSelect: '#publisher',
							content: 'Copied!',
						})
						setTimeout(() => {
							tooltipCopyPublisher.current?.close()
						}, 2000)
					}}
				>
					<Tooltip imperativeModeOnly ref={tooltipCopyPublisher} />
					<TypographyParagraph
						size="medium"
						additionalClasses="text-textSecondaryLight dark:text-textSecondaryDark"
					>
						Publisher:
					</TypographyParagraph>
					<TypographyParagraph
						size="medium"
						additionalClasses="ml-2 text-textPrimaryLight dark:text-textPrimaryDark"
					>
						{mediaCitation.properties.publisher}
					</TypographyParagraph>
				</div>
			)}
			{mediaCitation.properties.date && (
				<div
					id="date"
					className="flex flex-row border-b border-textInactiveLight p-4 hover:bg-uiSecondaryLight dark:border-textInactiveDark dark:hover:bg-uiSecondaryDark"
					onClick={() => {
						navigator.clipboard.writeText(mediaCitation.properties.date)
						tooltipCopyPublishingDate.current?.open({
							anchorSelect: '#date',
							content: 'Copied!',
						})
						setTimeout(() => {
							tooltipCopyPublishingDate.current?.close()
						}, 2000)
					}}
				>
					<Tooltip imperativeModeOnly ref={tooltipCopyPublishingDate} />
					<TypographyParagraph
						size="medium"
						additionalClasses="text-textSecondaryLight dark:text-textSecondaryDark"
					>
						Publishing Date:
					</TypographyParagraph>
					<TypographyParagraph
						size="medium"
						additionalClasses="ml-2 text-textPrimaryLight dark:text-textPrimaryDark"
					>
						{mediaCitation.properties.date}
					</TypographyParagraph>
				</div>
			)}
			{mediaCitation.properties.author && (
				<div
					id="author"
					className="flex flex-row border-b border-textInactiveLight p-4 hover:bg-uiSecondaryLight dark:border-textInactiveDark dark:hover:bg-uiSecondaryDark"
					onClick={() => {
						navigator.clipboard.writeText(mediaCitation.properties.author)
						tooltipCopyAuthor.current?.open({
							anchorSelect: '#author',
							content: 'Copied!',
						})
						setTimeout(() => {
							tooltipCopyAuthor.current?.close()
						}, 2000)
					}}
				>
					<Tooltip imperativeModeOnly ref={tooltipCopyAuthor} />
					<TypographyParagraph
						size="medium"
						additionalClasses="text-textSecondaryLight dark:text-textSecondaryDark"
					>
						Author:
					</TypographyParagraph>
					<TypographyParagraph
						size="medium"
						additionalClasses="ml-2 text-textPrimaryLight dark:text-textPrimaryDark"
					>
						{mediaCitation.properties.author}
					</TypographyParagraph>
				</div>
			)}
			<div
				id="signature"
				className="flex flex-row p-4 hover:bg-uiSecondaryLight dark:hover:bg-uiSecondaryDark"
				onClick={() => {
					navigator.clipboard.writeText(mediaCitation.signature)
					tooltipCopySignature.current?.open({
						anchorSelect: '#signature',
						content: 'Copied!',
					})
					setTimeout(() => {
						tooltipCopySignature.current?.close()
					}, 2000)
				}}
			>
				<Tooltip imperativeModeOnly ref={tooltipCopySignature} />
				<TypographyParagraph
					size="medium"
					additionalClasses="text-textSecondaryLight dark:text-textSecondaryDark"
				>
					Signature:
				</TypographyParagraph>
				<TypographyParagraph
					size="medium"
					additionalClasses="ml-2 text-textPrimaryLight dark:text-textPrimaryDark break-all"
				>
					{mediaCitation.signature}
				</TypographyParagraph>
			</div>
		</>
	)
}
